export function standardizeCategories(categories, categorySetting) {
    let result = [];

    for (const i of categories) {
        result.push(categorySetting[i]);
    }

    return result;
}

export function isHasProcedureBelongToCategory(category, procedures) {
    for (const i of procedures) {
        if (i.service_categories?.map((i) => i.name).includes(category.name)) {
            return true;
        }
    }
    return false;
}

export function convertCategory(category) {
    return category.replace(/[^a-zA-Z0-9]/g, '');
}

export function isHasProcedureBelongToCategorySurgical(category, procedures) {
    for (const i of procedures) {
        if (i.surgical == 1) {
            return true;
        }
    }
    return false;
}
